import React from 'react'
import Hero from './components/hero/hero'
import About from './components/about/about'

export default function Home() {
  return (
    <>
      <Hero />
      <About />
    </>
  )
}
